<template>
        <v-flex >
          <v-toolbar flat class="transparent mx-auto mb-4">
            <v-btn icon v-on:click.native="goBack()" >
                <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title class="headline">{{msg}}</v-toolbar-title>
          </v-toolbar>
          <voice-calendar-stats class="mb-4" v-if="false" ></voice-calendar-stats>
          <voice-data-table-stats  class="mb-4"></voice-data-table-stats>
        </v-flex>
</template>

<script>
import VoiceCalendarStats from './stats/CalendarStats.vue'
import DataTableStats from './stats/DataTableStats.vue'

export default {
  data () {
    return {
      msg: 'Stats',
    }
  },
  components: {
            'voice-calendar-stats': VoiceCalendarStats,
            'voice-data-table-stats': DataTableStats
  },
  methods: {
    goBack(){ this.$router.back(); }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Stats.vue